import ReactDOM from 'react-dom/client';
import './index.css';
import "@interopio/home-ui-react/index.css";
import "@interopio/workspaces-ui-react/dist/styles/workspaces.css";
import reportWebVitals from './reportWebVitals';
import Main from './main';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <Main />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
